import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import Services from "@/pages/Services";
import Gallery from "@/pages/Gallery";
import WorkDetail from "@/pages/WorkDetail";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import Refer from "@/pages/Refer";
import Feedback from "@/pages/Feedback";
import Admin from "@/pages/Admin";
import InstagramAdmin from "@/pages/InstagramAdmin";
import SiteHead from "@/components/SiteHead";
import { Toaster } from "@/components/ui/sonner";
import { SiteConfigProvider } from "@/lib/siteConfig";
import { EditModeProvider } from "@/lib/editMode";

function App() {
    return (
        <div className="App">
            <SiteConfigProvider>
                <EditModeProvider>
                    <BrowserRouter>
                    <SiteHead />
                    <Routes>
                        <Route element={<Layout />}>
                            <Route path="/" element={<Home />} />
                            <Route path="/services" element={<Services />} />
                            <Route path="/quotes" element={<Navigate to="/services" replace />} />
                            <Route path="/gallery" element={<Gallery />} />
                            <Route path="/work/:slug" element={<WorkDetail />} />
                            <Route path="/articles" element={<Blog />} />
                            <Route path="/articles/:slug" element={<BlogPost />} />
                            <Route path="/blog" element={<Navigate to="/articles" replace />} />
                            <Route path="/blog/:slug" element={<Navigate to="/articles" replace />} />
                            <Route path="/refer" element={<Refer />} />
                            <Route path="/my-rev-cash" element={<Navigate to="/refer" replace />} />
                            <Route path="/feedback" element={<Feedback />} />
                            <Route path="/about" element={<About />} />
                            <Route path="/contact" element={<Contact />} />
                            <Route path="/admin" element={<Admin />} />
                            <Route path="/admin/instagram" element={<InstagramAdmin />} />
                        </Route>
                    </Routes>
                </BrowserRouter>
                </EditModeProvider>
            </SiteConfigProvider>
            <Toaster position="top-center" theme="dark" />
        </div>
    );
}

export default App;
